// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__uYOaK","fullSideBar":"styles_fullSideBar__91CNG","halfSideBar":"styles_halfSideBar__dVULi"};